import { r as createLogger } from "../logger-CdXeOlrX.js";
import { OccluderMeshDriver } from "./occluder-mesh-driver.js";
//#region ../src/visualization/occluder-mesh-worker-client.ts
const log = createLogger("OccluderMeshWorker");
/**
* Create an {@link OccluderMeshDriver} that meshes off the main thread. Returns
* the driver plus a `dispose` that also terminates the worker. If the worker
* can't be created (no support, or `createWorker` throws), the driver falls back
* to synchronous main-thread meshing — the occluder still works, just on-thread.
*
* @param createWorker the app's worker (e.g. `new Worker(new URL(
*   './occlusion-mesher.worker.ts', import.meta.url), { type: 'module' })`).
*/
function createOccluderMeshWorker(createWorker) {
	const { worker, poster } = tryCreateWorker(createWorker);
	const driver = new OccluderMeshDriver(poster, {
		onError: (err) => log.warn("Occluder mesh worker job failed", err),
		onWorkerUnusable: () => {
			log.warn("Occluder mesh worker unusable; meshing synchronously");
			worker?.terminate();
		},
		onMeshStats: (s) => log.debug(`Meshed ${s.cellCount} cells (${s.mode}) in ${Math.round(s.durationMs)} ms${s.synchronous ? " [sync]" : ""}`)
	});
	return {
		driver,
		dispose: () => {
			driver.dispose();
			worker?.terminate();
		}
	};
}
/** Create the worker + its poster adapter, or `{null, null}` on any failure. */
function tryCreateWorker(createWorker) {
	try {
		const worker = createWorker();
		const poster = {
			postMessage: (message, transfer) => worker.postMessage(message, transfer),
			onmessage: null,
			onerror: null
		};
		worker.onmessage = (event) => {
			poster.onmessage?.({ data: event.data });
		};
		worker.onerror = (event) => {
			poster.onerror?.(event.message ?? event);
		};
		worker.onmessageerror = (event) => {
			poster.onerror?.(event);
		};
		return {
			worker,
			poster
		};
	} catch (err) {
		log.warn("Occluder mesh worker unavailable; meshing synchronously", err);
		return {
			worker: null,
			poster: null
		};
	}
}
//#endregion
export { createOccluderMeshWorker };
